// extracted by mini-css-extract-plugin
export var posts = "blog-module--posts--p4vu7";
export var post = "blog-module--post--AganZ";
export var meta = "blog-module--meta--RZgm1";
export var featured = "blog-module--featured--WEvBX";
export var excerpt = "blog-module--excerpt--Lh5fl";
export var button = "blog-module--button--CnTTV";